import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { media } from '../ui/common';
import { colors } from '../../../ui/common';

export const Row = styled.div`
  display: flex;
  justify-content: center;
  .carousel__next-button,
  .carousel__back-button {
    background: transparent;
    border: none;
    padding: 0 16px;
    outline: none;
  }
  .carousel__inner-slide {
    overflow: hidden;
  }
  svg {
    fill: ${colors.color05};
  }
  ${media.phone`
    margin-top: 32px;
  `}
  ${media.laptop`
    margin-top: 48px;
  `}
`;
export const Wrap = styled.div`
  width: 100%;
  height: 252px;
  overflow: hidden;
  position: relative;
  .carousel__dot-group {
    position: absolute;
    bottom: 7px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    mix-blend-mode: difference;
  }
  .carousel__dot {
    width: 6px;
    height: 6px;
    padding: 0;
    margin: 0 2px;
    border: 1px solid #fff;
    box-sizing: border-box;
    background: transparent;
    border-radius: 50%;
  }
  .carousel__dot--selected {
    background: #fff;
  }
  .carousel__slider-tray {
    transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  ${media.phone`
    height: 80px;
    width: 450px;
  `}
`;
export const Tiny = styled(GatsbyImage)`
  width: 100%;
  height: 250px;
  border: 1px solid
    ${(props) => (props.$active ? colors.color05 : 'transparent')};
  ${media.phone`
    margin: 0 5px;
    width: 100px;
    height: 80px;
    border-radius: 5px;
    overflow: hidden;
    box-sizing: border-box;
  `};
  @media (max-width: 599px) {
    border: none;
  }
`;
